import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class FullScreenMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    a,
    o,
    p,
    m,
    n,
    u,
    c,
    f,
    d,
    l,
    g,
    j,
    x,
    z,
    h,
    v,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
  ) {
    (p = p || InAppMessage.DismissType.MANUAL),
      (k = k || InAppMessage.Orientation.PORTRAIT),
      super(
        e,
        r,
        void 0,
        s,
        t,
        i,
        a,
        o,
        p,
        m,
        n,
        u,
        c,
        f,
        d,
        l,
        g,
        j,
        x,
        z,
        h,
        v,
        w,
        y,
        S,
        (b = b || InAppMessage.CropType.CENTER_CROP),
        k,
        q,
        A,
      ),
      (this.Te = InAppMessage.TextAlignment.CENTER);
  }
  tt() {
    return super.tt(FullScreenMessage.et);
  }
  static an(e) {
    return new FullScreenMessage(
      e[InAppMessage.it.ea],
      e[InAppMessage.it.ra],
      e[InAppMessage.it.jt],
      e[InAppMessage.it.sa],
      e[InAppMessage.it.ta],
      e[InAppMessage.it.URI],
      e[InAppMessage.it.ia],
      e[InAppMessage.it.oa],
      e[InAppMessage.it.pa],
      e[InAppMessage.it.ma],
      e[InAppMessage.it.nt],
      e[InAppMessage.it.na],
      e[InAppMessage.it.ua],
      e[InAppMessage.it.ca],
      e[InAppMessage.it.fa],
      e[InAppMessage.it.da],
      e[InAppMessage.it.la],
      e[InAppMessage.it.ga],
      e[InAppMessage.it.ja],
      e[InAppMessage.it.xa],
      e[InAppMessage.it.za],
      e[InAppMessage.it.ha],
      e[InAppMessage.it.va],
      pe(e[InAppMessage.it.wa]),
      e[InAppMessage.it.ya],
      e[InAppMessage.it.Sa],
      e[InAppMessage.it.ba],
      e[InAppMessage.it.CSS],
    );
  }
}
FullScreenMessage.et = InAppMessage.qe.on;
